export class SetDeviceID {
    public static readonly type = '[Root State] Set device id';

    constructor(public deviceID: string) {}
}
